import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as moment from "moment";
import { Form, Formik } from "formik";
import {
  getPostInitialValues,
  VALIDATION_SCHEMA,
} from "web/components/utils/setupCommissionModalUtils";
import {
  add_commission_user,
  update_commission,
} from "redux/actions/CommissionModule";
import styled from "styled-components";
import NumberInput from "web/components/form-elements/NumberInput";
import TextInput from "web/components/form-elements/TextInput";
import DatePicker from "web/components/form-elements/DatePicker";
import Select from "web/components/form-elements/Select";
import AlertModal from "web/components/AlertModal";
import CloseIcon from "web/assets/images/CloseIcon.png";
import { storeAdminDetails, logoutAdmin } from "redux/actions/admin";

function SetupCommissionModal({
  toggle,
  locationResoonse,
  commissionList,
  editFlag,
}) {
  const dispatch = useDispatch();
  let history = useHistory();
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState("");

  const [alertType, setAlertType] = useState();
  const [commissionModeType, setCommissionModeType] = useState("%");

  useEffect(() => {
    if (commissionList?.commissionMode === "FLAT") {
      setCommissionModeType("$");
    } else {
      setCommissionModeType("%");
    }
  }, []);

  useEffect(() => {}, []);

  let obj = [
    {
      value: "INTERNAL",
      label: "Internal",
    },
    {
      value: "AFFILIATE",
      label: "Affiliate",
    },
  ];
  let commissionMode = [
    {
      value: "PERCENTAGE",
      label: "Percentage",
    },
    {
      value: "FLAT",
      label: "Flat",
    },
  ];
  let orderType = [
    {
      value: "ONE_TIME",
      label: "One Time",
    },
    {
      value: "PER_ORDER",
      label: "Per Order",
    },
  ];

  const setUpCommission = async (props) => {

    if (
      props.values.addLocationInput !== "INTERNAL" &&
      props.values.companyName === ""
    ) {
      setAlertModalContent("Company name is required.");
      setAlertModal(true);
      return true;
    }
    if (
      props.values.addLocationInput === "INTERNAL" &&
      props.values.role === ""
    ) {
      setAlertModalContent("Role is required.");
      setAlertModal(true);
      return true;
    }

    let data = {
      name: props.values.name,
      email: props.values.email,
      commissionType: props.values.addLocationInput,
      locationId: locationResoonse?.locationId || "",
      locationName: locationResoonse?.companyName,
      role: props.values.role || "NA",
      companyName: props.values.companyName || "NA",
      commissionMode: props.values.commissionMode,
      commissionValue: props.values.commissionValue
        .split("%")
        .join("")
        .split("$")
        .join(""),
      minTransValue: props.values.minTransValue
        .split(",")
        .join("")
        .substring(1),
      orderType: props.values.orderType,
      startDate: moment(props.values.commissionStartDate).format("MM/DD/YYYY"),
      endDate: moment(props.values.commissionEndDate).format("MM/DD/YYYY"),
    };
    const token = localStorage.getItem("token");

    let response = await dispatch(add_commission_user(data, token));

    if (response.status === "SUCCESS") {
      setAlertModalContent(response?.message);
      setAlertModal(!alertModal);
      setAlertType("success");
    } else {
      if (response?.statusCode === 401) {
        adminLogout();
      } else {
        setAlertModalContent(response?.message);
        setAlertModal(true);
      }
    }
  };
  const updateCommission = async (commissionList, props) => {

    let data = {
      id: commissionList?.id,
      name: props.values.name,
      companyName: props.values.companyName || "NA",
      email: props.values.email,
      role: props.values.role || "NA",
      commissionMode: props.values?.commissionMode,
      commissionValue: props.values?.commissionValue
        ?.split("%")
        .join("")
        .split("$")
        .join(""),
      minTransValue: props.values?.minTransValue?.split("$").join(""),
      orderType: props.values.orderType,
      startDate: moment(props.values.commissionStartDate).format("MM/DD/YYYY"),
      endDate: moment(props.values.commissionEndDate).format("MM/DD/YYYY"),
    };
    const token = localStorage.getItem("token");

    let response = await dispatch(update_commission(data, token));
    if (response.status === "SUCCESS") {
      setAlertModalContent(response?.message);
      setAlertModal(!alertModal);
      setAlertType("success");
    } else {
      if (response?.statusCode === 401) {
        adminLogout();
      } else {
        setAlertModalContent(response?.message);
        setAlertModal(true);
      }
    }
  };

  const adminLogout = () => {
    dispatch(storeAdminDetails([], {}));
    dispatch(logoutAdmin());
    localStorage.removeItem("adminRolesData");
    localStorage.removeItem("adminName");
    localStorage.removeItem("adminEmail");
    localStorage.removeItem("token");
    history.push("./sign-in");
    window.location.reload(false);
  };

  return (
    <>
      <div>
        <div className="modal-header-style">
          <h6>Commission Setup</h6>
          <img
            src={CloseIcon}
            alt="close-icon"
            onClick={() => {
              toggle();
            }}
          />
        </div>

        <Formik
          initialValues={getPostInitialValues(commissionList, editFlag)}
          validationSchema={VALIDATION_SCHEMA()}
          onSubmit={(values) => {}}
        >
          {(props) => {
            const { isValid, dirty, setFieldValue } = props;

            return (
              <Form>
                <div
                  style={{ padding: "25px 25px 0px", "padding-bottom": "0px" }}
                >
                  <InputFieldsWrapper>
                    {!editFlag && (
                      <div className="row">
                        <div className="col-md-4 select-wrapper-style mb-4">
                          <h5 className="mb-2">
                            Commission Module<span className="star">&#42;</span>
                          </h5>
                          <Select
                            name="addLocationInput"
                            placeholder="Commission Module"
                            data={obj}
                            //disabled={pageProps.formikProps?.values?.flatFeeSpecEdit}
                            onChangeHandler={(event) => {
                              if (event.value === "INTERNAL") {
                                setFieldValue("companyName", "");
                              } else {
                                setFieldValue("role", "");
                              }
                            }}
                          />
                        </div>
                        <div className="col-md-8"></div>
                      </div>
                    )}
                    <div className="row mb-3">
                      <div className="col-md-4 col-sm-6 date-border-adjust">
                        <h5 className="mb-2">
                          Contact Name<span className="star">&#42;</span>
                        </h5>
                        <TextInput
                          name="name"
                          placeholder={`Contact Name`}
                          disabled={editFlag ? true : false}
                          inputType="text"
                        />
                      </div>
                      {props.values.addLocationInput !== "INTERNAL" ? (
                        <div className="col-md-4 col-sm-6 date-border-adjust">
                          <h5 className="mb-2">
                            Company Name<span className="star">&#42;</span>
                          </h5>
                          <TextInput
                            name="companyName"
                            placeholder={`Company Name`}
                            disabled={editFlag ? true : false}
                            inputType="companyText"
                          />
                        </div>
                      ) : (
                        <div className="col-md-4 col-sm-6 date-border-adjust">
                          <h5 className="mb-2">
                            Role<span className="star">&#42;</span>
                          </h5>
                          <TextInput
                            name="role"
                            placeholder={`Role`}
                            disabled={editFlag ? true : false}
                            inputType="text"
                          />
                        </div>
                      )}
                      <div className="col-md-4 col-sm-12 date-border-adjust">
                        <h5 className="mb-2">
                          Email Address<span className="star">&#42;</span>
                        </h5>
                        <TextInput
                          name="email"
                          placeholder="Email"
                          // disabled={editFlag?true:false}
                          disabled={editFlag ? true : false}
                          maxLength={100}
                          showErrorMessages={true}
                        />
                      </div>
                    </div>

                    <div className="row mb-3">
                      {/* <div className="col-md-4 col-sm-6 date-border-adjust">
                        <h5 className="mb-2">
                          Role<span className="star">&#42;</span>
                        </h5>
                        <TextInput
                          name="role"
                          placeholder={`Role`}
                          disabled={editFlag?true:false}
                          inputType="text"
                        />
                      </div> */}
                      <div className="col-md-4 col-sm-6 date-border-adjust select-wrapper-style">
                        <h5 className="mb-2">
                          Commission Type<span className="star">&#42;</span>
                        </h5>
                        <Select
                          name="commissionMode"
                          placeholder="Commission Type"
                          data={commissionMode}
                          disabled={editFlag ? true : false}
                          onChangeHandler={(event) => {
                            if (event.value === "FLAT") {
                              setCommissionModeType("$");
                            } else {
                              setCommissionModeType("%");
                            }
                            setFieldValue("commissionValue", "");
                          }}
                        />
                      </div>

                      <div className="col-md-4 col-sm-6 date-border-adjust select-wrapper-style">
                        <h5 className="mb-2">
                          Commission Value<span className="star">&#42;</span>
                        </h5>
                        <NumberInput
                          name="commissionValue"
                          placeholder=""
                          maxLength={commissionModeType === "%" ? "" : 11}
                          decimalScale={commissionModeType === "%" ? 3 : 2}
                          disabled={editFlag ? true : false}
                          prefix={commissionModeType !== "%" ? "$" : ""}
                          suffix={
                            commissionModeType === "%" ? commissionModeType : ""
                          }
                          showErrorMessages={true}
                        />
                      </div>
                      <div className="col-md-4 col-sm-6 date-border-adjust select-wrapper-style">
                        <h5 className="mb-2">
                          Min. Trans. Value<span className="star">&#42;</span>
                        </h5>
                        <NumberInput
                          name="minTransValue"
                          placeholder=""
                          maxLength={11}
                          disabled={editFlag ? true : false}
                          prefix={"$"}
                          showErrorMessages={true}
                        />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4 date-border-adjust select-wrapper-style">
                        <h5 className="mb-2">
                          Order Type<span className="star">&#42;</span>
                        </h5>
                        <Select
                          name="orderType"
                          placeholder="Order Type"
                          data={orderType}
                          disabled={editFlag ? true : false}
                          onChangeHandler={(val) => {}}
                        />
                      </div>
                      <div className="col-md-4 col-sm-6 date-border-adjust modal-date-picker-style">
                        <h5 className="mb-2">
                          Start Date<span className="star">&#42;</span>
                        </h5>
                        <DatePicker
                          name="commissionStartDate"
                          placeholderText=""
                          max={props.values.commissionEndDate}
                          type="DatesDisabled"
                          disabled={editFlag ? true : false}
                          editedValuePrefill={
                            editFlag ? commissionList.startDate : ""
                          }
                          callBackFun={(date) => {}}
                        />
                      </div>
                      <div className="col-md-4 col-sm-6 date-border-adjust modal-date-picker-style">
                        <h5 className="mb-2">
                          Expiry Date<span className="star">&#42;</span>
                        </h5>
                        <DatePicker
                          name="commissionEndDate"
                          placeholderText=""
                          type="DatesDisabled"
                          // disabled={editFlag?true:false}
                          min={props.values.commissionStartDate}
                          editedValuePrefill={
                            editFlag ? commissionList?.endDate : ""
                          }
                          callBackFun={(date) => {}}
                        />
                      </div>
                    </div>
                  </InputFieldsWrapper>
                </div>

                <InputFieldsWrapper>
                  <div
                    className="submitBtn"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      "margin-bottom": "20px",
                    }}
                  >
                    <button
                      className="green-button"
                      disabled={!(isValid && dirty)}
                      onClick={() => {
                        if (editFlag) {
                          updateCommission(commissionList, props);
                        } else {
                          setUpCommission(props);
                        }
                      }}
                    >
                      {editFlag ? "Update" : "Submit"}
                    </button>
                  </div>
                </InputFieldsWrapper>
              </Form>
            );
          }}
        </Formik>
      </div>
      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        content={alertModalContent}
        alertType={alertType}
        callBackAlert={(val) => {
          if (val === "success") {
            toggle();
          }
        }}
      />
    </>
  );
}

export default SetupCommissionModal;

const InputFieldsWrapper = styled.div`
  .css-os3nnz-control {
    border: none;
  }
  .app-input-text {
    font-size: 15px;
  }
  .css-1lmoifu-control {
    background-color: #fff !important;
    border-color: #fff !important;
    border-bottom: 1px solid rgb(225, 225, 225) !important;
  }
  .modal-date-picker-style {
    .file-input-wrapper .MuiFormControl-root {
      height: 37px;
      border: none;
      border-bottom: 1px solid rgb(225, 225, 225) !important;
    }
    .file-input-wrapper .MuiFormControl-root .MuiInput-root {
      height: 100%;
      padding: 2px 0;
      input {
        border: none !important;
      }
    }
  }
  .select-wrapper-style {
    /* margin-bottom: 30px; */
    .react-select__control {
      border-radius: 0;
      border-bottom: 1px solid rgb(225, 225, 225) !important;
    }
    .react-select__value-container {
      padding: 0;
    }
    .react-select__input {
      input {
        border: none !important;
      }
    }
  }
  h5 {
    color: #ababab;
    font-size: 11px;
    margin-bottom: 3px;
  }
  h4 {
    text-align: center;
    font-weight: bold;
    font-size: 26px;
  }
  h5 {
    /* text-align: center; */
    font-size: 14px;
    margin: 17px 0 0 0px;
    max-width: 370px;
  }
  p {
    color: #ef5657;
    font-size: 11px;
    margin-top: 2px;
  }
  img {
    top: 4px !important;
    left: 6px !important;
    width: 20px;
    height: 20px;
  }
  input {
    border: none;
    border-bottom: 1px solid #e1e1e1;
    border-radius: 0;
    padding: 0;
    border-top: none;
    border-right: none;
    border-left: none;
    border-image: initial;
    border-bottom: 1px solid rgb(225, 225, 225) !important;
    border-radius: 0px;
    padding: 0px;
  }

  .flatType {
    input:disabled {
      background-color: hsl(0, 0%, 95%) !important;
    }
  }
  .fixed-height {
    position: relative;
    min-height: 72px;
    .height-adjust {
      position: absolute;
      top: 15px;
      width: 90%;
    }
  }
  .date-style {
    border: 1px solid #87cdf1 !important;
    border-radius: 2px !important;
    padding: 0px 20px 0 15px !important;
  }
  .green-button {
    background: linear-gradient(90deg, #55c416 1.12%, #367910 100%);
    border: none;
    border-radius: 5px;
    height: 30px;
    color: #fff;
    font-size: 14px;
  }
  .bordered-input {
    input {
      border: 1px solid #87cdf1;
      border-radius: 5px;
      padding: 0px 10px 0px 10px;
    }
  }
  .date-border-adjust {
    input {
      border: none;
      /* padding: 5px; */
    }
  }
  .error-styling-input {
    input {
      border: none !important;
      border-bottom: 1px solid #ef5657 !important;
    }
  }
  .table thead th,
  .table td,
  .table th {
    font-size: 14px;
  }
  .userlist-header {
    display: flex;
    justify-content: space-between;
    padding: 10px 0 15px 0;
    h1 {
      font-size: 16px;
      font-weight: bold;
    }
    img {
      cursor: pointer;
    }
  }
  .app-input-text {
    margin-bottom: 15px !important;
  }
  .app-input-text input.error {
    border: none !important;
    border-bottom: 1px solid #ef5657 !important;
  }
  .radio-checkmark {
    top: 2.5px !important;
    border: 1px solid #005586 !important;
  }
  .radio-checkmark:after {
    background: #005586 !important;
  }
  .radioField {
    span {
      font-size: 14px;
    }
  }
  .checkbox-field {
    margin: 0 0 0 14px !important;
  }
  .checkbox-container {
    font-size: 14px !important;
  }
  .checkMark {
    border: solid 2px #d5d5d5 !important;
  }

  /* When the checkbox is checked, add a blue background */
  .checkbox-container input:checked ~ .checkMark {
    background: linear-gradient(to bottom, #f7f9fa 0%, #f7f9fa 100%) !important;
  }
  .checkbox-container input:checked ~ .checkMarkDisable:after {
    display: block;
  }
  .checkbox-container .checkMarkDisable:after {
    left: 6px;
    top: 2px;
    width: 6px;
    height: 11px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }

  .checkMarkDisable:after {
    content: "";
    position: absolute;
    display: none;
  }
  .checkbox-container input:checked ~ .checkMarkDisable {
    position: absolute;
    top: 0;
    left: 0;
    background-color: transparent;
    border-radius: 2px;
    border: solid 2px #979797;
    height: 21px;
    width: 21px;
    background: linear-gradient(to bottom, #979797 0%, #979797 100%);
  }

  .checkMarkDisable:after {
    border: solid black !important;
    border-width: 0 3px 3px 0 !important;
  }
  /* Style the checkMark/indicator */
  .checkMark:after {
    border: solid black !important;
    border-width: 0 3px 3px 0 !important;
  }

  .input-disabled {
    .app-input-text {
      input {
        background: #f2f2f2;
      }
    }
  }
  .submitBtn button:disabled {
    background: linear-gradient(90deg, #979797 1.12%, #979797 100%) !important;
    color: -internal-light-dark(
      rgba(16, 16, 16, 0.3),
      rgba(255, 255, 255, 0.3)
    ) !important;
    border-color: -internal-light-dark(
      rgba(118, 118, 118, 0.3),
      rgba(195, 195, 195, 0.3)
    ) !important;
  }
  .completion-page {
    height: 435px;
    padding: 90px 0 100px 0;
    text-align: center;
    img {
      width: 55px;
      height: 55px;
      margin: 20px;
    }
    .save-button {
      background: #005586;
      padding: 5px;
      width: 68px;
      border-radius: 5px;
      color: #fff;
      border: none;
    }
  }

  input:disabled {
    opacity: 0.5;
  }
`;
